// src/pages/VerifyEmailPage.tsx
import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { verifyEmail } from '../api/verifyService';
import logo from '../assets/damelio_logo_negro.png';
import logo2 from '../assets/damelio_texto_negro.png';
import { useTranslation } from 'react-i18next';

const VerifyEmailPage: React.FC = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  // i18n
  const { t } = useTranslation();

  // Estado para mostrar el mensaje al usuario
  const [message, setMessage] = useState<string>(t('verifyEmail.validating') as string);

  // Obtenemos el token de la URL
  const token = params.get('token');
  const hasVerified = useRef(false); // Flag para evitar llamadas repetidas

  useEffect(() => {
    const doVerify = async () => {
      if (!hasVerified.current && token) {
        hasVerified.current = true;
        try {
          const resp = await verifyEmail(token);
          if (resp.status === 200) {
            // Respuesta podría ser { "message": "Email verificado con éxito" } o similar
            if (resp.data && resp.data.message) {
              setMessage(resp.data.message);
            } else {
              setMessage(t('verifyEmail.success'));
            }
          } else {
            // Podrías mostrar un error del backend
            setMessage(t('verifyEmail.unableToVerify'));
          }
        } catch (error: any) {
          console.error(error);
          setMessage(t('verifyEmail.error'));
        }
      }
    };
    doVerify();
  }, [token, t]);

  const handleGoDashboard = () => {
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-sm w-full bg-white p-6 rounded shadow space-y-6">
        {/* Logos: puedes usar la misma lógica que PaymentSuccessPage */}
        <div
          className="text-center cursor-pointer group transition-transform duration-300"
          onClick={() => navigate('/dashboard')}
        >
          <img
            src={logo}
            alt="Damelio Logo"
            className="mx-auto h-32 w-auto transition-transform duration-300"
          />
          <img
            src={logo2}
            alt="Damelio Texto"
            className="mx-auto h-16 w-auto mt-2 transition-transform duration-300"
          />
        </div>

        {/* Título */}
        <h2 className="text-center text-2xl font-bold mb-2">
          {t('verifyEmail.title')}
        </h2>

        {/* Mensaje */}
        <p className="text-center text-gray-700 whitespace-pre-line">{message}</p>

        {/* Botón para ir al Dashboard */}
        <div className="text-center mt-4">
          <button
            onClick={handleGoDashboard}
            className="inline-block py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white rounded shadow"
          >
            {t('verifyEmail.goDashboard')}
          </button>
          <p className="text-sm text-gray-600 mt-2">
            {t('verifyEmail.extraInfo')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
